import { Minus, Plus, Trash2 } from "lucide-react";

const brl = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" });

export const ProductRow = ({ item, qty, owner, onAdd, onDec, onEdit, onRemove }) => (
    <div
        data-testid={`demo-item-${item.id}`}
        className="flex items-start justify-between gap-4 border-b border-gray-100 bg-white px-4 py-4 last:border-0 sm:px-5"
    >
        <div className="min-w-0 flex-1">
            {owner ? (
                <div className="space-y-2">
                    <input
                        data-testid={`demo-edit-nome-${item.id}`}
                        value={item.nome}
                        onChange={(e) => onEdit(item.id, "nome", e.target.value)}
                        className="w-full rounded-lg border border-red-300 bg-red-50/50 px-2.5 py-1.5 text-sm font-semibold text-gray-800 outline-none focus:border-[#EA1D2C]"
                    />
                    <input
                        value={item.desc}
                        onChange={(e) => onEdit(item.id, "desc", e.target.value)}
                        className="w-full rounded-lg border border-gray-200 bg-gray-50 px-2.5 py-1.5 text-xs text-gray-500 outline-none focus:border-[#EA1D2C]"
                    />
                </div>
            ) : (
                <>
                    <h3 className="text-[15px] font-semibold text-gray-800">{item.nome}</h3>
                    <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-gray-400">{item.desc}</p>
                </>
            )}
            <div className="mt-2.5">
                {owner ? (
                    <input
                        data-testid={`demo-edit-preco-${item.id}`}
                        type="number"
                        min="0"
                        step="0.5"
                        value={item.preco}
                        onChange={(e) => onEdit(item.id, "preco", Number(e.target.value))}
                        className="w-24 rounded-lg border border-red-300 bg-red-50/50 px-2.5 py-1 text-sm font-bold text-[#EA1D2C] outline-none focus:border-[#EA1D2C]"
                    />
                ) : (
                    <span className="text-sm font-bold text-gray-800">{brl.format(item.preco)}</span>
                )}
            </div>
        </div>

        <div className="relative h-24 w-28 shrink-0">
            <img
                src={item.img}
                alt={item.nome}
                loading="lazy"
                className="h-full w-full rounded-xl object-cover"
            />
            {owner ? (
                <button
                    data-testid={`demo-remove-${item.id}`}
                    onClick={() => onRemove(item.id)}
                    className="absolute -bottom-2 right-2 flex h-8 w-8 items-center justify-center rounded-full border border-gray-200 bg-white text-red-500 shadow-md transition-colors hover:bg-red-50"
                    aria-label={`Remover ${item.nome}`}
                >
                    <Trash2 size={14} />
                </button>
            ) : qty === 0 ? (
                <button
                    data-testid={`demo-add-${item.id}`}
                    onClick={() => onAdd(item.id)}
                    className="absolute -bottom-2 right-2 flex h-8 w-8 items-center justify-center rounded-full border border-gray-200 bg-white text-[#EA1D2C] shadow-md transition-transform duration-200 hover:scale-110"
                    aria-label={`Adicionar ${item.nome}`}
                >
                    <Plus size={17} strokeWidth={2.75} />
                </button>
            ) : (
                <div
                    data-testid={`demo-qty-${item.id}`}
                    className="absolute -bottom-2 right-2 flex h-8 items-center gap-2 rounded-full border border-gray-200 bg-white px-1.5 text-[#EA1D2C] shadow-md"
                >
                    <button onClick={() => onDec(item.id)} data-testid={`demo-dec-${item.id}`} className="p-1" aria-label="Diminuir">
                        <Minus size={14} strokeWidth={3} />
                    </button>
                    <span className="min-w-3 text-center text-xs font-extrabold">{qty}</span>
                    <button onClick={() => onAdd(item.id)} className="p-1" aria-label="Aumentar">
                        <Plus size={14} strokeWidth={3} />
                    </button>
                </div>
            )}
        </div>
    </div>
);
